import {en, he} from 'vuejs-datepicker/dist/locale'
import notifier from './notifier';

export default {
	mixins: [notifier],
	data () {
		return {
			task: {
				description: '',
				startDate: ''
			},
			activePromptAddEvent: false,
			createAffairPopupKey: 0,
			activePromptEditEvent: false,
			langHe: he,
			langEn: en,
			disabledFrom: false,
			activePromptAssignToManager: false,
			taskToAssign: null,
			assignedManager: null,
			managersList:[],
      loading: false,
		}
	},
	methods: {
		onAddTask (e) {
			this.clearPopupData()
			this.task.startDate = e.date;
			this.$nextTick(() => {
				this.activePromptAddEvent = true;
				this.$nextTick(() => this.createAffairPopupKey++);
			});
		},
		onEditTask (task) {
			this.clearPopupData()
			this.task = task.originalEvent || task;
			this.activePromptEditEvent = true
		},

		async addTask () {
			if(await this.$validator.validateAll() !== true || this.loading) return false;

      try {
        this.loading = true

        const obj = {
          description: this.task.description,
          date_time: this.$moment(this.task.startDate).format('YYYY-MM-DD HH:mm:ss')
        }
        let formData = this.$formData(obj)
        await this.$store.dispatch('calendar/addEvent', formData)
        await this.$store.dispatch('updateNotifications');
				this.notifySuccess(this.$t('successNotification'));
  
        return true;
      } catch (err) {
        console.error(err);
				this.notifyError('Error while creating task');
      } finally {
        this.loading = false
      }
		},

		onAssignToManager (e) {
			this.taskToAssign =e;
			this.activePromptAssignToManager = true;
		},
		assignToManager (e) {
			this.$store.dispatch('calendar/assignTaskToManager', {
				task: this.taskToAssign,
				manager: this.assignedManager
			});
			this.taskToAssign=null;
			this.assignedManager=null
		},
		clearPopupData () {
			this.task = {
				description: '',
				startDate: ''
			}
		},
		removeTask () {
			this.$store.dispatch('calendar/deleteTask', this.task)
			this.activePromptEditEvent = false
			this.clearPopupData()
		},
		showAssignTaskToManager(){
			this.activePromptEditEvent = false
			this.activePromptAssignToManager=true;
			this.taskToAssign = this.task;
		},
		async setTaskCompleted () {
			await this.$store.dispatch('calendar/setTaskCompleted', this.task)
		},
		buildManagerForSelect(item) {
			return {
				username: `${item.first_name} ${item.last_name}`,
				id: item.id
			};
		}
	},
	computed: {
		validForm () {
			return !!this.task.description && !!this.task.startDate
		},
		disabledDatesTo () {
			return {to: new Date(this.startDate)}
		},
		disabledDatesFrom () {
			return {from: new Date(this.endDate)}
		}
	}
}
